/* eslint-disable max-len */
import React, {
  FC,
} from 'react';
import './housingApplicationsDetails.scss';
import {
  Redirect, Route, generatePath, useHistory, useParams,
} from 'react-router-dom';
import { useQuery } from '@apollo/client';
import DashboardWrap from '../../../components/DashboardWrap';
import EmptyPageLoader from '../../../components/EmptyPageLoader';
import GoBackIcon from '../../../svgs/GoBackIcon';
import SummaryDetailsCover from '../../../components/SummaryDetailsCover';
import UserDetailsCardCa from '../../../components/UserDetailsCardCa';
import { GET_ADMIN_APARTMENT_DETAILS } from '../../../graphql/admin_queries';
import { HomeApplication } from '../../../interfaces/homeApplication';
import { cleanUpSingleHomeApplication } from '../../../utils/helpers';
import { AdminRouteName } from '../../CONSTANTS';
import HouseApplicationsDetailsMonitor from './HouseApplicationsDetailsMonitor';
import HouseApplicationsDetailsProfile from './HouseApplicationsDetailsProfile';
import AdminTab from '../../../components/AdminTab';
// import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
// import PermissionDenied from '../../PermissionDenied';

const HouseApplicationsDetails: FC = () => {
  const history = useHistory();
  const { id } = useParams<{id: string}>();
  const { data, refetch, loading } = useQuery<
  {
    getAdminApartmentDetailSingle: {data: HomeApplication};
  },
  { getAdminApartmentDetailSingleId: string }
>(GET_ADMIN_APARTMENT_DETAILS, { variables: { getAdminApartmentDetailSingleId: id } });

  const payload = cleanUpSingleHomeApplication(data?.getAdminApartmentDetailSingle?.data);

  const tabOptions: any = [
    { name: 'Profile', link: generatePath(AdminRouteName.housingApplicationDetailsProfileRoute, { id }) },
    {
      name: 'Application Monitoring', link: generatePath(AdminRouteName.housingApplicationDetailsApplicationRoute, { id }),
    },
  ];

  const tabs = tabOptions?.map((tab) => ({
    ...tab,
    disabled: false,
  }));

  return (
    <DashboardWrap>
      {/* <RolesAndPermissionGuard permissionName="can-view-guarantee-details" hasErrorTemplate={<PermissionDenied height="100vh" />}> */}
      <div className="housing-application-details-root">
        <div className="" style={{ display: loading ? 'block' : 'none' }}>
          <EmptyPageLoader />
        </div>
        <div className="content" style={{ display: loading ? 'none' : 'block' }}>
          <div className="title">
            <GoBackIcon onClick={() => history?.goBack()} />
            Housing Applications
          </div>
          <div className="ref-id-and-badge">
            <span className="ref-span">Housing Ref:</span>
            <span className="ref-no-span">{id}</span>
            <div className="badge-span">Canada Housing</div>
          </div>
          {payload && (
            <div className="summary-cover">
              <SummaryDetailsCover paddingBottom="0px">
                <UserDetailsCardCa payload={payload} fetchUser={refetch} paddingBottom="15px" />
                <div>
                  <AdminTab tabs={tabs} />
                </div>
                <div className="house-application-tab-view">
                  <Route path={AdminRouteName.housingApplicationDetailsProfileRoute}>
                    <HouseApplicationsDetailsProfile payload={payload} />
                  </Route>
                  <Route path={AdminRouteName.housingApplicationDetailsApplicationRoute}>
                    <HouseApplicationsDetailsMonitor payload={payload} refetchData={refetch} />
                  </Route>
                  <Route path={AdminRouteName.housingApplicationDetailsRoute} exact>
                    <Redirect to={generatePath(AdminRouteName.housingApplicationDetailsProfileRoute, { id })} />
                  </Route>
                </div>
              </SummaryDetailsCover>
            </div>
          )}
        </div>
      </div>
      {/* </RolesAndPermissionGuard> */}
    </DashboardWrap>
  );
};

export default HouseApplicationsDetails;
